import React from "react";

import "./styles.css";

export default function SwitchButton({ handleToggle }) {
  return (
    <div >
      <input
        type='checkbox'
        id='switch'
        className='checkbox'
        onClick={handleToggle}
      />
      <label for='switch' class='toggle'>
        <p style={{ float: "left", margin: "8px" }}> BUY</p>
        <p style={{ float: "right", margin: "8px" }}>SELL</p>
      </label>
    </div>
  );
}
